export default __webpack_public_path__ + "static/media/mock_stand_image_warning.2dc9a28c.jpg";